import { getDeviceType } from '../Utils/helper';

export const handleUserReviewPopupState = (setShowCarouselPopup, router) => {
  const device = getDeviceType();
  if (device == 'mWeb') {
    const params = new URLSearchParams(window.location.search);
    params.set('productImageGallery', 'true');
    router.push(`${window.location.pathname}/?${params}`, undefined, {
      shallow: true,
      scroll: false,
    });
  } else {
    setShowCarouselPopup(true);
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
  }
};
